import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscover = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 12,
	viewBox: "0 0 34 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0114 6.34067C19.5399 6.34067 20.7791 5.12195 20.7791 3.61858C20.7791 2.11521 19.5399 0.896484 18.0114 0.896484C16.4828 0.896484 15.2437 2.11521 15.2437 3.61858C15.2437 5.12195 16.4828 6.34067 18.0114 6.34067Z",
			fill: "#EF9122"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2437 3.61858C15.2437 2.10049 16.4678 0.896484 18.0114 0.896484C19.5549 0.896484 20.7791 2.10049 20.7791 3.61858C20.7791 5.13667 19.5549 6.34067 18.0114 6.34067",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0952 1.6817C17.1597 0.634745 18.9162 0.634745 19.9807 1.6817C21.0452 2.72866 21.0452 4.45614 19.9807 5.5031",
			fill: "#F44500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.99031 1.05249H0.5V6.18259H1.99031C2.7887 6.18259 3.37418 5.9732 3.85321 5.60676C4.43869 5.13563 4.81126 4.40276 4.81126 3.61754C4.81126 2.09945 3.69353 1.05249 1.99031 1.05249ZM3.2145 4.92624C2.89515 5.18798 2.46934 5.34502 1.83064 5.34502H1.51128V1.94241H1.77741C2.41612 1.94241 2.84192 2.0471 3.16127 2.36119C3.53385 2.67528 3.74675 3.14641 3.74675 3.61754C3.79998 4.08867 3.58708 4.61215 3.2145 4.92624Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.30132 1.05249H5.29004V6.18259H6.30132V1.05249Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85607 3.04206C8.21737 2.83267 8.05769 2.67562 8.05769 2.41388C8.05769 2.09979 8.37704 1.83806 8.80285 1.83806C9.1222 1.83806 9.38833 1.94275 9.65446 2.25684L10.1867 1.57632C9.76091 1.20988 9.22865 1.00049 8.64317 1.00049C7.73834 1.00049 6.99318 1.62866 6.99318 2.46623C6.99318 3.1991 7.31253 3.51319 8.27059 3.87963C8.6964 4.03667 8.85607 4.08902 8.96252 4.19371C9.17543 4.29841 9.28188 4.5078 9.28188 4.71719C9.28188 5.13598 8.96252 5.45007 8.48349 5.45007C8.00446 5.45007 7.57866 5.18833 7.36576 4.76954L6.72705 5.39772C7.20608 6.07824 7.79156 6.39233 8.53672 6.39233C9.60123 6.39233 10.3464 5.7118 10.3464 4.71719C10.3464 3.82728 10.027 3.46084 8.85607 3.04206Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.666 3.61819C10.666 5.13628 11.8902 6.28793 13.4337 6.28793C13.8595 6.28793 14.2321 6.18324 14.7112 5.97385V4.76985C14.2853 5.18863 13.9128 5.34567 13.487 5.34567C12.4757 5.34567 11.7305 4.6128 11.7305 3.56584C11.7305 2.57123 12.4757 1.78601 13.4337 1.78601C13.9128 1.78601 14.2853 1.94306 14.7112 2.36184V1.15784C14.2853 0.948446 13.9128 0.84375 13.4337 0.84375C11.9434 0.948446 10.666 2.15245 10.666 3.61819Z",
			fill: "#3B3D3F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0675 4.50746L21.6837 1.05249H20.5659L22.7482 6.33964H23.3336L25.6223 1.05249H24.5046L23.0675 4.50746Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0483 6.18259H28.9757V5.34502H27.1128V3.93163H28.9225V3.04171H27.1128V1.94241H28.9757V1.05249H26.0483V6.18259Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.8497 4.03632C32.6481 3.87928 33.0739 3.3558 33.0739 2.57058C33.0739 1.62832 32.382 1.05249 31.211 1.05249H29.6675V6.18259H30.6788V4.14102H30.8384L32.2755 6.18259H33.4997L31.8497 4.03632ZM30.9981 3.40815H30.6788V1.83771H30.9981C31.6368 1.83771 32.0094 2.09945 32.0094 2.62293C32.0094 3.14641 31.6368 3.40815 30.9981 3.40815Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.99031 1.05249H0.5V6.18259H1.99031C2.7887 6.18259 3.37418 5.9732 3.85321 5.60676C4.43869 5.13563 4.81126 4.40276 4.81126 3.61754C4.81126 2.09945 3.69353 1.05249 1.99031 1.05249ZM3.2145 4.92624C2.89515 5.18798 2.46934 5.34502 1.83064 5.34502H1.51128V1.94241H1.77741C2.41612 1.94241 2.84192 2.0471 3.16127 2.36119C3.53385 2.67528 3.74675 3.14641 3.74675 3.61754C3.79998 4.08867 3.58708 4.61215 3.2145 4.92624Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.30132 1.05249H5.29004V6.18259H6.30132V1.05249Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85607 3.04206C8.21737 2.83267 8.05769 2.67562 8.05769 2.41388C8.05769 2.09979 8.37704 1.83806 8.80285 1.83806C9.1222 1.83806 9.38833 1.94275 9.65446 2.25684L10.1867 1.57632C9.76091 1.20988 9.22865 1.00049 8.64317 1.00049C7.73834 1.00049 6.99318 1.62866 6.99318 2.46623C6.99318 3.1991 7.31253 3.51319 8.27059 3.87963C8.6964 4.03667 8.85607 4.08902 8.96252 4.19371C9.17543 4.29841 9.28188 4.5078 9.28188 4.71719C9.28188 5.13598 8.96252 5.45007 8.48349 5.45007C8.00446 5.45007 7.57866 5.18833 7.36576 4.76954L6.72705 5.39772C7.20608 6.07824 7.79156 6.39233 8.53672 6.39233C9.60123 6.39233 10.3464 5.7118 10.3464 4.71719C10.3464 3.82728 10.027 3.46084 8.85607 3.04206Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4867 6.28724C13.9125 6.28724 14.2851 6.18255 14.7641 5.97316V4.76915C14.3383 5.18794 13.9657 5.34498 13.5399 5.34498C12.5286 5.34498 11.7835 4.61211 11.7835 3.56515C11.7835 3.04167 11.9964 2.62289 12.3157 2.25645L11.6238 1.57593C11.0915 2.04706 10.719 2.77993 10.719 3.56515C10.6657 5.13559 11.8899 6.28724 13.4867 6.28724Z",
			fill: "#595A5B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.8497 4.03632C32.6481 3.87928 33.0739 3.3558 33.0739 2.57058C33.0739 1.62832 32.382 1.05249 31.211 1.05249H29.6675V6.18259H30.6788V4.14102H30.8384L32.2755 6.18259H33.4997L31.8497 4.03632ZM30.9981 3.40815H30.6788V1.83771H30.9981C31.6368 1.83771 32.0094 2.09945 32.0094 2.62293C32.0094 3.14641 31.6368 3.40815 30.9981 3.40815Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.00488 10.9468V8.06763L10.0275 10.1092V8.22467H10.4533V11.1038L8.43069 9.06224V10.9468H8.00488Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5821 8.64339H11.4644V9.27157H12.5289V9.69035H11.4644V10.5803H12.5821V10.9467H11.0386V8.22461H12.5821V8.64339Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9131 8.64329V10.9466H13.4873V8.64329H12.8486V8.27686H14.5518V8.64329H13.9131Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.19 8.27706L15.8819 10.1092L16.6271 8.17236L17.319 10.1092L18.0641 8.27706H18.5964L17.3722 11.1562L16.6803 9.21932L15.9351 11.1562L14.7642 8.27706H15.19Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6499 9.58576C18.6499 9.21932 18.8096 8.85289 19.0757 8.59115C19.3418 8.32941 19.7144 8.17236 20.087 8.17236C20.4596 8.17236 20.8322 8.32941 21.0983 8.59115C21.3644 8.85289 21.5241 9.21932 21.5241 9.58576C21.5241 9.95219 21.3644 10.3186 21.0983 10.5804C20.8322 10.8421 20.4596 10.9991 20.087 10.9991C19.7144 10.9991 19.3951 10.8945 19.1289 10.6327C18.8096 10.371 18.6499 10.0569 18.6499 9.58576ZM19.0757 9.58576C19.0757 9.89984 19.1822 10.1092 19.3951 10.3186C19.608 10.528 19.8209 10.6327 20.087 10.6327C20.3531 10.6327 20.6192 10.528 20.8322 10.3186C21.0451 10.1092 21.1515 9.89984 21.1515 9.58576C21.1515 9.27167 21.0451 9.06228 20.8322 8.85289C20.6192 8.64349 20.4063 8.5388 20.087 8.5388C19.8209 8.5388 19.5547 8.64349 19.3418 8.85289C19.1822 9.06228 19.0757 9.32402 19.0757 9.58576Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0142 9.79505L23.8658 10.9467H23.3336L22.5352 9.8474H22.482V10.9467H22.0562V8.22461H22.5352C22.9078 8.22461 23.1739 8.27696 23.3336 8.434C23.4932 8.59105 23.5997 8.80044 23.5997 9.00983C23.5997 9.21922 23.5465 9.37627 23.44 9.48096C23.3336 9.69035 23.1739 9.79505 23.0142 9.79505ZM22.482 9.48096H22.5884C22.961 9.48096 23.1739 9.32392 23.1739 9.06218C23.1739 8.80044 22.961 8.64339 22.5884 8.64339H22.4287V9.48096H22.482Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6646 9.32402L25.7291 8.22471H26.2613L25.0372 9.42871L26.2613 10.8945H25.7291L24.7178 9.69045L24.6114 9.79515V10.8945H24.1855V8.17236H24.6114V9.32402H24.6646Z",
			fill: "#F26E21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0709 5.34567H27.1128V4.4034L26.0483 3.35645V6.18323H28.9225L28.0709 5.34567Z",
			fill: "#3B3D3F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.2385 1.57597L23.0675 4.50746L21.6837 1.05249H20.5659L22.7482 6.33964H23.3336L25.0369 2.36119L24.2385 1.57597Z",
			fill: "#3B3D3F"
		})
	]
});
export default SvgDiscover;
